export const timeLogsContainer = {
  bg: "white",
  p: 6,
  borderRadius: "lg",
  boxShadow: "md",
  w: { base: "320px", md: "360px" },
};

export const timeLogTitle = {
  fontWeight: "600",
  color: "#1D287A",
  fontSize: "18px",
  mb: "8px",
};

export const statBox = {
  flex: 1,
  bg: "#CCEDCC",
  pt: 1,
  pb: 3,
  borderRadius: "md",
  textAlign: "center",
};
export const statBoxOverdue = {
  flex: 1,
  bg: "#FFEBEE",
  pt: 1,
  pb: 3,
  borderRadius: "md",
  textAlign: "center",
};
export const statBoxUpcoming = {
  flex: 1,
  bg: "#FBEBD0",
  pt: 1,
  pb: 3,
  borderRadius: "md",
  textAlign: "center",
};

export const statLabel = {
  fontSize: "10px",
  fontWeight: 300,
  fontFamily: "Poppins",
  color: "#212121",
};

export const statValue = {
  fontWeight: "bold",
  fontSize: "lg",
  color: "purple.600",
};

export const logItem = {
  justifyContent: "space-between",
  alignItems: "center",
  p: 2,
  borderBottom: "1px solid",
  borderColor: "gray.100",
};

export const logTime = {
  backgroundColor: "#5F4DC7",
  borderRadius: "12px",
  px: 4,
  py: 1,
  color: "#fff",
  fontSize: "12px",
  fontFamily: "Poppins",
  fontWeight: "500px",
};

export const logsScrollable = {
  maxH:{ base: "300px", md: "360px" },
  overflowY: "auto",
};

export const viewMoreLessButton = {
  mt: 4,
  colorScheme: "purple",
  variant: "ghost",
  size: "sm",
  display: "flex",
  justifyContent: "center",
  width: "100%",
};
